export default __webpack_public_path__ + "static/media/SpiceEngage.f65ad7a3.svg";